import React, { useState } from 'react';
import * as API from '../../framework/API/api';
import { META_STATUS_TYPE } from './SocialMediaConstant';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { DateTimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import PublishOrUnPublishStatusCard from './PublishOrUnPublishStatusCard';
import ToastNotification from "../../components/ToastNotification";
import { TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';

const PublishOrUnPublishForm = ({ onClose, item = {}, isMobile = false, isPublished }) => {

    const lang = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [gridData, setGridData] = useState(item?.ad_data ?? []);

    const handlePublishOrUnpublish = async (value = {}) => {
        setIsLoading(true);
        let res = await API.publishOrUnPublishCampaign({ campaign_id: item?._id, ad_id: value?._id, isPublished: isPublished });
        if (!res?.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message });
            setIsLoading(false);
            return;
        }
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res?.message });
        setIsLoading(false);
        onClose();
    }

    const onPublishUnPublishButton = (value) => {
        return (<td>
            <RoundButton className='ml-2' onClick={() => handlePublishOrUnpublish(value)} title={isPublished ? "Publish" : "Un-Publish"} icon={value?.status === META_STATUS_TYPE.ACTIVE ? "arrow-up" : "arrow-down"} />
        </td>)
    }

    return (
        <BossDialog title={item?.name} width={isMobile ? "95%" : "65%"} onClose={onClose}>
            <EditPageHeader showTitle={false} isLoading={isLoading} onSubmit={handlePublishOrUnpublish} saveButtonTitle={isPublished ? "Publish All" : "Un-publish All"} onCancel={onClose} />
            <div className='mt-4'>
                <Grid resizable style={{ height: "40vh" }} data={gridData}>
                    <GridColumn title="Action" width="60px" cell={({ dataItem }) => onPublishUnPublishButton(dataItem)} />
                    <GridColumn field="ad.assetId" title="Asset Id" />
                    <GridColumn field="ad.title" title="Title" />
                    <GridColumn field="status" title="Status" cell={({ dataItem }) => <PublishOrUnPublishStatusCard dataItem={{ ...dataItem, ad_data: [dataItem] }} />}/>
                    <GridColumn field="audience.name" title="Audience" />
                    <GridColumn field='start_time' title='Start Time' cell={DateTimeCell} />
                    <GridColumn field='end_time' title='End Time' cell={DateTimeCell} />
                </Grid>
            </div>
        </BossDialog>
    )
}

export default PublishOrUnPublishForm;